export default __webpack_public_path__ + "static/media/OrangeStars.de08176f.svg";